import React from 'react';
import { motion } from 'framer-motion';
export function PrivacyPolicyPage() {
  return <div className="w-full" data-id="element-537">
      {/* Hero */}
      <section className="py-16 md:py-20 bg-primary text-white px-6" data-id="element-538">
        <div className="max-w-7xl mx-auto" data-id="element-539">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-540">
            <h1 className="text-4xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-541">
              Privacy Policy
            </h1>
            <p className="text-lg md:text-xl text-white/70 max-w-2xl" data-id="element-542">
              Your privacy is important to us. This policy outlines how Birds
              Nest Independent Living LLC handles your data.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-20 px-6 bg-background" data-id="element-543">
        <div className="max-w-4xl mx-auto bg-white p-6 md:p-20 rounded-3xl shadow-premium border border-gray-100" data-id="element-544">
          <div className="prose prose-slate max-w-none space-y-8 md:space-y-12" data-id="element-545">
            <div data-id="element-546">
              <h2 className="text-3xl font-display font-bold text-charcoal mb-6" data-id="element-547">
                1. Information We Collect
              </h2>
              <p className="text-muted leading-relaxed text-lg" data-id="element-548">
                We collect information that you provide directly to us when you
                fill out an inquiry form, submit a referral, or contact us for
                housing availability. This may include your name, email address,
                phone number, and any other details relevant to your housing
                needs.
              </p>
            </div>

            <div data-id="element-549">
              <h2 className="text-3xl font-display font-bold text-charcoal mb-6" data-id="element-550">
                2. How We Use Your Information
              </h2>
              <p className="text-muted leading-relaxed text-lg" data-id="element-551">
                The information we collect is used solely to provide and improve
                our independent living services. This includes:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-3 text-muted text-lg" data-id="element-552">
                <li data-id="element-553">Processing housing applications and referrals.</li>
                <li data-id="element-554">
                  Communicating with you regarding bed availability and tours.
                </li>
                <li data-id="element-555">
                  Connecting residents with community resources and healthcare
                  partners.
                </li>
                <li data-id="element-556">
                  Complying with legal and regulatory requirements in the state
                  of Maryland.
                </li>
              </ul>
            </div>

            <div data-id="element-557">
              <h2 className="text-3xl font-display font-bold text-charcoal mb-6" data-id="element-558">
                3. Data Security
              </h2>
              <p className="text-muted leading-relaxed text-lg" data-id="element-559">
                We implement a variety of security measures to maintain the
                safety of your personal information. Your data is stored in
                secure environments and is only accessible by authorized
                personnel who are required to keep the information confidential.
              </p>
            </div>

            <div data-id="element-560">
              <h2 className="text-3xl font-display font-bold text-charcoal mb-6" data-id="element-561">
                4. Third-Party Disclosure
              </h2>
              <p className="text-muted leading-relaxed text-lg" data-id="element-562">
                We do not sell, trade, or otherwise transfer your personally
                identifiable information to outside parties. This does not
                include trusted third parties who assist us in operating our
                website or conducting our business, so long as those parties
                agree to keep this information confidential.
              </p>
            </div>

            <div data-id="element-563">
              <h2 className="text-3xl font-display font-bold text-charcoal mb-6" data-id="element-564">
                5. Contact Us
              </h2>
              <p className="text-muted leading-relaxed text-lg" data-id="element-565">
                If you have any questions regarding this privacy policy, you may
                contact us using the information on our contact page.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}